<template>
  <R3Title title="Active Device List"></R3Title> <!-- unicode U+276F : ❯ -->

  <div v-if="loading" class="loading-overlay">
      LOADING...
      <span class="loader"></span>
  </div>
  <div v-else>
    <div class="content-block dx-card" id ="dataDiv">
      <DxDataGrid
        class="dx-card wide-card"
        :data-source="activeDevices"
        :hover-state-enabled="true"
        :selection="{ mode: 'single' }"
        :show-borders="true"
        :columns-auto-width="false"
        :column-min-width="50"
        :allow-column-resizing="true"
        :column-resizing-mode="columnResize"
        :allow-column-reordering="true"
        no-data-text="Loading ..."
        @initialized="saveGridInstance"
        :style="{ 'max-height': datagridHeight }"
      >
        <DxStateStoring
          :enabled="true"
          type="localStorage"
          storage-key="rep_active_devices"
        />
        <DxLoadPanel :enabled="true" />

        <DxColumn data-field="surface" caption="Surface" />
        <DxColumn data-field="alias" caption="Alias" />
        <DxColumn data-field="downholeLSD" caption="Downhole LSD" />
        <DxColumn data-field="imei" caption="IMEI" />
        <DxColumn data-field="manufacturer" caption="Manufacturer" />
        <DxColumn data-field="containerType" caption="Container Type" />
        <DxColumn data-field="model" caption="Model" />
        <DxColumn data-field="operator" caption="Operator" />
        <DxColumn data-field="area" caption="Area" />
        <DxColumn data-field="office" caption="Office" />
        <DxColumn data-field="district" caption="District" />
        <DxColumn data-field="product" caption="Product" />
        <DxColumn data-field="satellite" caption="Satellite" />
        <DxColumn data-field="latitude" caption="Latitude" />
        <DxColumn data-field="longitude" caption="Longitude" />
        <DxColumn data-field="contractName" caption="Contract Name" />
        <DxColumn data-field="contractDate" caption="Contract Date" />
        <DxColumn data-field="installDate" caption="Install Date" />
        <DxColumnChooser :enabled="true" mode="select" />
        <DxFilterRow :visible="true" />
        <DxHeaderFilter :visible="true" />
        <DxScrolling mode="standard" />
        <DxExport :enabled="true" />
        <DxColumnFixing :enabled="true" />
        <DxPager 
          :show-info="true" 
          :visible="true" 
          :show-page-size-selector="true" 
          :allowed-page-sizes="[20, 50, 100]"
          :show-navigation-buttons="true" 
        />
        <DxSorting mode="multiple" />
        <DxToolbar>
          <DxItem location="after" template="removeFilterRecordTemplate" />
          <DxItem location="after" template="refreshRecordTemplate" />
          <DxItem location="after" name="exportButton" />
          <DxItem location="after" name="columnChooserButton" />
        </DxToolbar>

        <template #refreshRecordTemplate>
          <DxButton icon="refresh" hint="Refresh Data" @click="refreshData" />
        </template>
        <template #removeFilterRecordTemplate>
          <DxButton icon="filter" hint="Clear Filters & Sorting" @click="removeFilter" />
        </template>
        
      </DxDataGrid>
    </div>
  </div>

  

</template>

<script>
import R3Title from "@/components/base/page-title.vue";
import {
  DxDataGrid,
  DxHeaderFilter,
  DxFilterRow,
  DxScrolling,
  DxColumnChooser,
  DxStateStoring,
  DxColumnFixing,
  DxPager,
  DxItem,
  DxExport,
  DxToolbar,
  DxLoadPanel,
  DxSorting,
  DxColumn
} from "devextreme-vue/data-grid";
import { DxButton } from 'devextreme-vue/button';

export default {
  components: 
  {
    R3Title,
    DxToolbar,
    DxItem,
    //   DxToolbarItem,
    DxDataGrid,
    DxColumn,
    DxPager,
    DxColumnFixing,
    DxStateStoring,
    DxHeaderFilter,
    DxFilterRow,
    DxScrolling,
    DxColumnChooser,
    DxButton,
    DxExport,
    DxLoadPanel,
    DxSorting
  },
  data() 
  {
    return {
      columnResize: 'widget',
      dataGridInstance: null,
      loadingVisible: false,
      isLoadPanelVisible: false,
      datagridHeight: '40vh',
      activeDevices: [],
      loading: true,
    };
  },
  created() 
  {
    this.loadPageData();
  },
  mounted() {
    window.addEventListener('resize', this.setDimensions);
    this.setDimensions();
  },
  unmounted() {
    window.removeEventListener('resize', this.setDimensions);
  },
  methods: 
  {
    async loadPageData(refresh = false) {
      this.loading = true;
      try {
        await this.$store.dispatch("devices/loadActiveDevices");
        this.activeDevices = await this.$store.getters["devices/getActiveDevices"];
        // console.log('activeDevices', this.activeDevices);

      } catch (error) {
        this.error = error.message || "Unexpected Error.";
      } finally {
        this.loading = false;
      }
    },
    setDimensions() {
      const h = document.documentElement.clientHeight;
      this.datagridHeight= (h-250) + 'px';
    },
    saveGridInstance: function(e) {
      this.dataGridInstance = e.component;
    },
    removeFilter(){
      this.dataGridInstance.clearFilter();
      this.dataGridInstance.clearSorting();
    },
    refreshData(){
      this.loadPageData();
    },
  },
};
</script>

<style scoped>
  h2 {
    margin-left: 1em; 
  }
</style>
